import { useContext, useMemo } from "react";
import { ContextApp } from "@config/Context/contextApp";
import { AppContext } from "../context/EditSessionsContext";
import { isLinkStarted } from "../utils/isLinkStarted";

import { isLinkValidForProgramming } from "@utils/programmingGroupState";
import { deriveProgrammingLockState, ProgrammingLockState } from "../utils/programmingLockState";

export const useProgrammingLockState = (): ProgrammingLockState => {
  const { user } = useContext(ContextApp);
  const { state } = useContext(AppContext);

  const isStarted = useMemo(
    () => isLinkStarted(state?.link?.sections, state?.form?.blockingThreshold),
    [state?.link?.sections, state?.form?.blockingThreshold],
  );

  return deriveProgrammingLockState({
    hasUnscheduledSessions: !!state?.link?.sections?.some(
      section => section?.unasignedSessions?.length > 0,
    ),
    hasProgrammingAbility: !!user?.abilities?.can_edit_programming,
    isEligibleForProgramming: isLinkValidForProgramming(state?.link?.info),
    hasAppliedStructure: !!state?.link?.info?.programmingStructure,
    isStarted,
    canEditStartedLinks: !!user?.abilities?.can_edit_programming_for_started_links,
  });
};
